import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { ComponentTextMedium } from '../Typography/Typography';
import * as styles from './MultiSelectButton.module.scss';
const Name = 'MultiSelectButton';
export const MultiSelectButton = ({ active = false, text, onClick, className, }) => (_jsx("button", { "aria-pressed": active, className: clsx(styles.container, className), "data-component": Name, onClick: onClick, children: _jsx(ComponentTextMedium, { centered: true, children: text }) }));
